module.exports = __webpack_public_path__ + "static/media/master-logo.fa264b52.png";